import styled from 'styled-components'

import {
  _S_Normal,
  FloatingContainer,
  mainColors,
  rgba,
  shadowColors,
  TextFieldInputContainer,
  zIndex,
} from '@avantstay/backoffice-core'
import { IconChevronDown } from '@avantstay/backoffice-vectors'

export const Container = styled(FloatingContainer)`
  min-width: 170px;
  background: ${mainColors.white};
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 2px;
  box-shadow: 0px 4px 16px 0px ${rgba(shadowColors.blur, 0.4)};
  margin-top: 10px;
  z-index: ${zIndex.FLOATING_CONTAINER_TOGGLER};
`

export const ReadOnlyInput = styled(TextFieldInputContainer)`
  ${_S_Normal};

  min-width: fit-content;
  justify-content: space-between;
  gap: 12px;
  text-align: right;
  padding: 2px 10px;
  cursor: pointer;

  span {
    max-width: max-content;
    color: ${mainColors.neutralExtremelyDark};
  }
`

export const DropdownIcon = styled(IconChevronDown)<{ $isActive?: boolean }>`
  width: 14px;
  max-width: 14px;
  height: 16px;
  color: ${mainColors.neutralExtraDark};
  transform: scale(${({ $isActive }) => ($isActive ? -1 : 1)});
`
